import React, { useState } from "react"
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { graphql } from '@apollo/client/react/hoc'
import PrimaryListingContainer from "../Material/PrimaryListingContainer"
import { AllNotificationTemplatesQuery } from "./Queries"
import withApolloClient from '../withApolloClient'
import "./NotificationTemplatesList.css"

const tableHeaders = [
    { id: "name", name: "name", sortable: false },
    { id: "subject", name: "subject", sortable: false },
    { id: "actions", name: "actions", sortable: false }
]


const NotificationTemplatesList = ({ updateOrder, loading, orderBy, history, allNotificationTemplates }) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    const toggleModal = (template) => {
        setSelectedTemplate(template || null)
        setModalOpen(!modalOpen)
    }

    return (
        <div className="AutomationList" >
            <PrimaryListingContainer listLoading={loading}>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            {tableHeaders.map(tableHeader => tableHeader.sortable ?
                                <th key={tableHeader.id} onClick={() => updateOrder(tableHeader.id)} style={{ cursor: "pointer" }}>{orderBy.some(order => order.includes(tableHeader.id)) ? <i className={"fa " + (orderBy.includes(tableHeader.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i> : <i className='fa fa-sort'></i>}&nbsp;&nbsp;{tableHeader.name}</th> :
                                <th key={tableHeader.id}>{tableHeader.name}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {allNotificationTemplates && allNotificationTemplates && allNotificationTemplates.length > 0 ? allNotificationTemplates.map((notificationTemplates, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{notificationTemplates.name ? notificationTemplates.name : "--"}</td>
                                <td>
                                    {notificationTemplates.subject ? notificationTemplates.subject : "--"}
                                </td>
                                <td>
                                    <a className="driver-list-button" onClick={() => toggleModal(notificationTemplates)}>Show Details</a>
                                </td>
                            </tr>
                        )) : !loading &&
                        <tr>
                            <td colSpan={tableHeaders.length + 1} className="text-center">No Notification Templates Found</td>
                        </tr>
                        }
                    </tbody>
                </Table>
            </PrimaryListingContainer>
            {selectedTemplate &&
                <Modal isOpen={modalOpen} toggle={() => toggleModal(null)} size="lg">
                    <ModalHeader >Template Details</ModalHeader>
                    <ModalBody>
                        <p><strong>Name:</strong> {selectedTemplate.name || "--"}</p>
                        <p><strong>Subject:</strong> {selectedTemplate.subject || "--"}</p>
                        <p><strong>Description:</strong> {selectedTemplate.description || "--"}</p>
                        <p><strong>Body:</strong></p>
                        <div className="notification-template-body" dangerouslySetInnerHTML={{ __html: selectedTemplate.body || "--" }} />
                    </ModalBody>
                    <ModalFooter>
                        <Button outline color="secondary" onClick={() => toggleModal(null)}>Close</Button>
                    </ModalFooter>
                </Modal>
            }
        </div>
    )
}

//-----------------------------------
export default graphql(AllNotificationTemplatesQuery, {
    options: () => ({ variables: {} }),
    props: ({ data: { loading, error, allNotificationTemplates } }) => ({
        loading,
        error,
        allNotificationTemplates,
    }),
})(withApolloClient(NotificationTemplatesList))
